(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShowcase(root) {
      if (!root || root.dataset.showcaseReady === 'true') return;

      var slider = root.querySelector('[data-slider]');
      var track = root.querySelector('[data-track]');
      var dotsEl = root.querySelector('[data-dots]');
      var prevBtn = root.querySelector('[data-prev]');
      var nextBtn = root.querySelector('[data-next]');
      if (!slider || !track || !dotsEl || !prevBtn || !nextBtn) return;

      var realSlides = Array.prototype.slice.call(track.children);
      var realCount = realSlides.length;
      if (realCount === 0) return;

      root.dataset.showcaseReady = 'true';

      var mq = window.matchMedia('(max-width: 820px)');

      // Build infinite clones once: [cloneLast, ...real, cloneFirst]
      var firstClone = realSlides[0].cloneNode(true);
      var lastClone = realSlides[realCount - 1].cloneNode(true);
      firstClone.classList.add('homepage-product-showcase__clone');
      firstClone.classList.remove('homepage-product-showcase__slide');
      lastClone.classList.add('homepage-product-showcase__clone');
      lastClone.classList.remove('homepage-product-showcase__slide');
      track.insertBefore(lastClone, realSlides[0]);
      track.appendChild(firstClone);

      // Dots
      for (var i = 0; i < realCount; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.className = 'homepage-product-showcase__dot' + (idx === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Ga naar product ' + (idx + 1));
          b.addEventListener('click', function () {
            goTo(idx + 1, true);
          });
          dotsEl.appendChild(b);
        })(i);
      }
      var dots = Array.prototype.slice.call(dotsEl.children);

      var index = 1; // start on first real slide
      var enabled = false;

      function step() {
        var s = track.children[1];
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return s.getBoundingClientRect().width + gap;
      }
      function offset() {
        var s = track.children[1];
        return (slider.clientWidth - s.getBoundingClientRect().width) / 2;
      }
      function place(animate) {
        track.style.transition = animate ? 'transform .42s cubic-bezier(.4,.01,.2,1)' : 'none';
        track.style.transform = 'translateX(' + (offset() - index * step()) + 'px)';
      }
      function setDots() {
        var real = (((index - 1) % realCount) + realCount) % realCount;
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === real);
        });
      }
      function goTo(i, animate) {
        index = i;
        place(animate);
        setDots();
      }

      track.addEventListener('transitionend', function () {
        if (index === 0) {
          index = realCount;
          place(false);
        } else if (index === realCount + 1) {
          index = 1;
          place(false);
        }
      });

      nextBtn.addEventListener('click', function () {
        goTo(index + 1, true);
      });
      prevBtn.addEventListener('click', function () {
        goTo(index - 1, true);
      });

      // ---- drag / swipe ----
      var down = false;
      var startX = 0;
      var startT = 0;
      var dragging = false;
      function curX() {
        return offset() - index * step();
      }
      function onDown(e) {
        if (!enabled) return;
        down = true;
        dragging = false;
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        startT = curX();
        track.style.transition = 'none';
      }
      function onMove(e) {
        if (!down) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        var dx = x - startX;
        if (Math.abs(dx) > 4) {
          dragging = true;
          slider.classList.add('is-dragging');
        }
        track.style.transform = 'translateX(' + (startT + dx) + 'px)';
      }
      function onUp(e) {
        if (!down) return;
        down = false;
        slider.classList.remove('is-dragging');
        var x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        var dx = x - startX;
        var threshold = step() * 0.18;
        if (dx < -threshold) goTo(index + 1, true);
        else if (dx > threshold) goTo(index - 1, true);
        else place(true);
      }
      slider.addEventListener('mousedown', onDown);
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
      slider.addEventListener('touchstart', onDown, { passive: true });
      slider.addEventListener('touchmove', onMove, { passive: true });
      slider.addEventListener('touchend', onUp);
      // Prevent ghost click after a drag
      track.addEventListener(
        'click',
        function (e) {
          if (dragging) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      function enable() {
        enabled = true;
        index = 1;
        place(false);
        setDots();
      }
      function disable() {
        enabled = false;
        track.style.transition = 'none';
        track.style.transform = 'none';
      }
      function sync() {
        if (mq.matches) enable();
        else disable();
      }

      if (mq.addEventListener) mq.addEventListener('change', sync);
      else mq.addListener(sync);
      window.addEventListener('resize', function () {
        if (enabled) place(false);
      });
      sync();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-showcase]');
      Array.prototype.forEach.call(roots, initShowcase);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when a section is reloaded in the theme editor
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-showcase]');
      if (root) initShowcase(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
